import { FormattedDate, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { FormattedCurrency } from '../../../iwIntlProvider/FormattedCurrency';
import { parseTransactionNumber } from '../AccountHistory';
import * as selectors from '../AccountHistorySelectors';
import messages from '../accountHistoryTable/AccountHistoryTable.messages';
import styles from './AccountHistoryTableMobile.module.css';
import { RootState } from '@iwProvider/configureStore';
import { GetStatementsResponse } from '@iwoca/lapi-client/edge';

const mapStateToProps = (
    state: RootState,
    ownProps: TAccountHistoryTableMobileProps
) => ({
    statements: selectors.getAccountHistory(state, ownProps.accountId),
    hasTransactions: selectors.hasMadeTransactions(state, ownProps.accountId)
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

type TAccountHistoryTableMobileProps = {
    accountType: string;
    accountId: string;
};

const AccountHistoryTableMobile = ({
    statements,
    hasTransactions,
    accountType
}: PropsFromRedux & TAccountHistoryTableMobileProps) => {
    if (!hasTransactions) {
        return (
            <div className={styles.AccountHistoryTableMobile}>
                <div className={styles.header}>
                    <div className={styles.title}>
                        <FormattedMessage {...messages.noTransactions} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div
            className={styles.AccountHistoryTableMobile}
            data-testid="account-history-table-mobile"
        >
            {statements.map((statement) => (
                <Statement
                    key={`statement-${statement.date}-${statement.closing_balance}`}
                    statement={statement}
                    accountType={accountType}
                />
            ))}
        </div>
    );
};

type TStatement = NonNullable<
    NonNullable<GetStatementsResponse['data']>[number]['statements']
>[number];

const Statement = ({
    statement,
    accountType
}: {
    statement: TStatement;
    accountType: string;
}) => (
    <div
        className={styles.statement}
        key={`statement-mob-${statement.date}-${statement.closing_balance}`}
        data-testid="mobile-statements"
    >
        <div className={styles.column}>
            <div className={styles.date}>
                <FormattedDate
                    day="numeric"
                    month="short"
                    year="numeric"
                    value={new Date(statement.date!)}
                />
            </div>
            <div className={styles.description}>{statement.description}</div>
        </div>
        <div className={styles.column}>
            {accountType !== 'merchant_cash_advance' && (
                <>
                    <div className={styles.principal}>
                        <FormattedMessage {...messages.principal} />{' '}
                        <FormattedCurrency
                            value={parseTransactionNumber(
                                statement.transaction_principal!
                            )}
                        />
                    </div>
                    <div className={styles.interest}>
                        <FormattedMessage {...messages.interest} />{' '}
                        <FormattedCurrency
                            value={
                                parseTransactionNumber(
                                    statement.transaction_interest!
                                ) +
                                parseTransactionNumber(
                                    statement.transaction_fees!
                                )
                            }
                        />
                    </div>
                </>
            )}
            <div className={styles.balance}>
                <FormattedMessage {...messages.balance} />{' '}
                <FormattedCurrency value={statement.closing_balance} />
            </div>
        </div>
    </div>
);

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(AccountHistoryTableMobile);
